'use client';

import { Dialog } from './Dialog';
import { DialogFooter } from './_components/DialogFooter';
import { DialogContent } from './_components/DialogContent';

type DialoglCompoundType = typeof Dialog & {
  Content: typeof DialogContent;
  Footer: typeof DialogFooter;
};

const DialogCompound = Dialog as DialoglCompoundType;

DialogCompound.Content = DialogContent;
DialogCompound.Footer = DialogFooter;

export { DialogCompound as Dialog };
